/**
 * Ultra-fast pure SVG Renderer and attribute diffing engine.
 */
export class Renderer {
  public static SVG_NS = 'http://www.w3.org/2000/svg';
  public static XLINK_NS = 'http://www.w3.org/1999/xlink';

  private static attributeCache: WeakMap<SVGElement, Map<string, string>> = new WeakMap();

  public static createElement<K extends keyof SVGElementTagNameMap>(tag: K): SVGElementTagNameMap[K] {
    return document.createElementNS(Renderer.SVG_NS, tag) as SVGElementTagNameMap[K];
  }

  public static setAttributes(el: SVGElement, attrs: Record<string, string | number | boolean | null | undefined>): void {
    let cache = Renderer.attributeCache.get(el);
    if (!cache) {
      cache = new Map();
      Renderer.attributeCache.set(el, cache);
    }

    for (const [key, rawVal] of Object.entries(attrs)) {
      if (rawVal === null || rawVal === undefined) {
        if (cache.has(key)) {
          el.removeAttribute(key);
          cache.delete(key);
        }
        continue;
      }

      const val = String(rawVal);
      if (cache.get(key) !== val) {
        el.setAttribute(key, val);
        cache.set(key, val);
      }
    }
  }

  public static applyTransform(el: SVGElement, transformStr: string): void {
    Renderer.setAttributes(el, { transform: transformStr });
  }

  public static applyStyles(el: SVGElement, styles: Partial<CSSStyleDeclaration>): void {
    for (const [prop, val] of Object.entries(styles)) {
      if (val !== undefined && val !== null) {
        (el.style as any)[prop] = val;
      }
    }
  }
}
